import { StyledTimeTicker } from './TimeTicker.styles';

export interface TimeTickerProps {
  height: number;
  top: number;
}

export const TimeTicker: React.FC<TimeTickerProps> = (props) => (
  <StyledTimeTicker {...props} className="TIMETICKER">
    <svg
      className="svgTop"
      xmlns="http://www.w3.org/2000/svg"
      width="14"
      height="12"
      viewBox="0 0 14 12"
      fill="none"
    >
      <path
        d="M7.21582 11.6816L0.968429 0.860838L13.4632 0.860839L7.21582 11.6816Z"
        fill="#3239FE"
      />
    </svg>
    <svg
      className="svgBottom"
      xmlns="http://www.w3.org/2000/svg"
      width="14"
      height="11"
      viewBox="0 0 14 11"
      fill="none"
    >
      <path
        d="M7.21582 6.30656e-07L0.968429 10.8208L13.4632 10.8208L7.21582 6.30656e-07Z"
        fill="#3239FE"
      />
    </svg>
  </StyledTimeTicker>
);
